const isValidValue = (val) => {
    return !!val || val === 0;
};
const getSizeInPx = (size) => {
    return typeof size === "number" ? `${size}px` : size;
};
const getSizeInRem = (size) => {
    // 1/16=0.0625, $sizeInPx/16=$sizeInPx*0.0625
    return typeof size === "number" ? `${size * 0.0625}rem` : size;
};
const clampNumber = (value, min, max) => {
    let result = value;
    if (isValidValue(max)) {
        result = Math.min(value, max);
    }
    if (isValidValue(min)) {
        result = Math.max(result, min);
    }
    return result;
};
const getPriceString = (price = 0, optionOveride) => {
    const defaultOption = {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    };
    return `${price.toLocaleString("en-IN", optionOveride || defaultOption)}`;
};
const calculateDiscount = (originalPrice, discountValue, discountType = "percentage") => {
    if (discountType === "percentage") {
        const discountAmount = (discountValue / 100) * originalPrice;
        const discountedPrice = originalPrice - discountAmount;
        return { discountAmount, discountedPrice, discountValue };
    }
    else if (discountType === "amount") {
        const discountPercentage = (discountValue / originalPrice) * 100;
        const discountedPrice = originalPrice - discountValue;
        return { discountValue, discountedPrice, discountPercentage };
    }
};

export { calculateDiscount, clampNumber, getPriceString, getSizeInPx, getSizeInRem, isValidValue };
//# sourceMappingURL=common.js.map
